<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex justify-between my-3">
  <h2>View Drivers</h2>
  <div class="flex flex-col-reverse min-[525px]:flex-row gap-2">
    <button nz-button class="outline-button" (click)="activeFilter()">{{driverStatus ? 'Show' : 'Hide'}}
      Inactive
    </button>
    <button *appHasAnyPrivilege="'DRIVER_CREATE'" nz-button nzType="primary" [routerLink]="'add-edit'">
      Add New Driver
    </button>
  </div>
</div>

<nz-card>
  <div class="flex flex-col gap-3">
    <div [ngClass]="loading ? 'hidden' : 'block'">
      <nz-collapse>
        <nz-collapse-panel [nzHeader]="'Advanced Search'">

          <div class="flex flex-col lg:flex-row sm:justify-between lg:items-end 2xl:items-center gap-4">

            <div class="flex flex-col lg:flex-row lg:items-end">


              <!--              <div class="flex flex-col lg:flex-row lg:items-center">-->
              <!--                <nz-divider class="hidden 2xl:block" [nzType]="'vertical'"></nz-divider>-->

              <!--                <nz-form-item class="flex flex-col xl:flex-row m-0">-->
              <!--                  <nz-form-label class="text-start">Filter by Status</nz-form-label>-->
              <!--                  <nz-select [(ngModel)]="driverStatus" (ngModelChange)="search()" nzPlaceHolder="Select Status"-->
              <!--                             [nzAllowClear]="true">-->
              <!--                    <nz-option [nzValue]="true" nzLabel="Active"></nz-option>-->
              <!--                    <nz-option [nzValue]="false" nzLabel="Inactive"></nz-option>-->
              <!--                  </nz-select>-->
              <!--                </nz-form-item>-->

              <!--                <nz-divider class="" [nzType]="'vertical'"></nz-divider>-->

              <nz-form-item class="flex flex-col xl:flex-row m-0">
                <nz-form-label class="text-start">Filter by Created date</nz-form-label>
                <nz-range-picker
                  class="w-full xl:w-auto"
                  [(ngModel)]="dateRanges"
                  nzFormat="yyyy/MM/dd"
                  ngModel
                  (ngModelChange)="search()"
                ></nz-range-picker>
              </nz-form-item>

              <!--              </div>-->
              <nz-divider class="hidden lg:block" [nzType]="'vertical'"></nz-divider>
              <!--              <div class="flex mt-2 lg:m-0">-->
              <nz-form-item class="m-0 mt-2 lg:m-0">
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton">
                  <input type="text" (keydown.enter)="search()" [(ngModel)]="searchText" nz-input
                         placeholder="Search Users"/>
                </nz-input-group>
                <ng-template #suffixIconSearchButton>
                  <button nz-button nzType="primary" nzSearch class="bg-[#6B6C6E] border-[#6B6C6E]"
                          (click)="search()">
                    <span nz-icon nzType="search"></span>
                  </button>
                </ng-template>
              </nz-form-item>
              <!--                <nz-divider-->
              <!--                  class="hidden lg:block"-->
              <!--                  [nzType]="'vertical'"-->
              <!--                ></nz-divider>-->
              <!--              </div>-->

            </div>

            <div>
              <button nz-button nzBlock class="outline-button" (click)="resetSearch()">
                Reset All
              </button>
            </div>

          </div>
        </nz-collapse-panel>
      </nz-collapse>
    </div>

    <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card">
      <div class="table-obj">
        <nz-table #basicTable [nzData]="driversData" [nzShowSizeChanger]="pageSize.length > 5"
                  [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
                  [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
                  (nzQueryParams)="onTableParamsChange($event)" nzTableLayout="auto"  [nzScroll]="{ x: 'auto', y:'550px'}"
                  nzOuterBordered>
          <thead>
          <tr>
            <th>Driver ID</th>
            <th>Driver Name</th>
            <th>Driver Contact No</th>
            <th>Driver Segment</th>
            <th>Driver Availability</th>
            <th>Supplier Name</th>
            <th>Supplier Contact No</th>
            <th>Last Transfer Date and Time</th>
            <th>Last Transfer Completion Time</th>
            <th>Next Transfer Allocated Date and Time</th>
            <th>
              <div class="flex">
                <span>Created Date</span>
                <span *ngIf="sortOrder === -1" nz-icon nzType="up" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
                <span *ngIf="sortOrder === 1" nz-icon nzType="down" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
              </div>
            </th>
            <!--            <th>Driver Status</th>-->
            <th *appHasAnyPrivilege="'DRIVER_SINGLE_VIEW,DRIVER_DELETE,DRIVER_UPDATE'">Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let data of basicTable.data">
            <td style="min-width: 150px;">
              <a *appHasAnyPrivilege="'DRIVER_SINGLE_VIEW'"
                 (click)="goto(data._id, 'single-view')">{{data?.refNo ? data?.refNo : '-'}}</a>
              <span *ngIf="!hasPermission('DRIVER_SINGLE_VIEW')">{{data?.refNo ? data?.refNo : '-'}}</span>
            </td>
            <td style="white-space: nowrap; min-width: 150px;">{{data?.fullName}}</td>
            <td class="clickable-mail-phone_no" style="white-space: nowrap; min-width: 200px;"><a class="clickable-mail-phone_no" href="tel:{{data?.mobileNumber}}">{{data?.mobileNumber}}</a></td>
            <td style="min-width: 150px;"
              >{{data?.driverSegment === 'SR_DRIVER' ? 'SR Driver' : 'Outsource Driver'}}</td>
            <td style="min-width: 150px;">
              <div *ngFor="let status of driverAvailabilityStatus">
                <nz-tag *ngIf="data?.driverAvailability === status.value" [nzColor]="status.colorCode" class="rounded-full">{{status.label}}</nz-tag>
              </div>
            </td>
            <td style="min-width: 150px; white-space: nowrap">{{data?.supplierName ? data?.supplierName : '-'}}</td>
            <td class="clickable-mail-phone_no" style="white-space: nowrap; min-width: 175px;"><a class="clickable-mail-phone_no font-normal" href="tel:{{data?.supplierContactNo ? data?.supplierContactNo : '-'}}">{{data?.supplierContactNo ? data?.supplierContactNo : '-'}}</a></td>
<!--            <td style="white-space: nowrap;">{{getTransferBookingsData(data, 'last')}}</td>-->
<!--            <td style="white-space: nowrap;">{{getTransferBookingsData(data, 'last-time')}}</td>-->
<!--            <td style="white-space: nowrap;">{{getTransferBookingsData(data, 'next')}}</td> -->
            <td style="min-width: 225px;">{{data?.lastTransBooking?.dateAndTime ? (data?.lastTransBooking?.dateAndTime | date: "dd-MM-y | hh:mm:a") : "-"}}</td>
            <td style="min-width: 250px;">{{data?.lastTransBooking?.endDateAndTime ? (data?.lastTransBooking?.endDateAndTime | date: "dd-MM-y | hh:mm:a") : "-"}}</td>
            <td style="min-width: 300px;">{{data?.nextTransBooking?.dateAndTime ? (data?.nextTransBooking?.dateAndTime | date: "dd-MM-y | hh:mm:a") : "-"}}</td>
            <!--            <td style="white-space: nowrap;">-->
            <!--              <div *ngIf="data.driverSegment === 'OUTSOURCE_DRIVER'">-->
            <!--                <div *ngIf="data?.vehicleDetails?.length > 0">-->
            <!--                  <div *ngFor="let vehicle of data?.vehicleDetails">{{vehicle.registerNumber}}</div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--              <div *ngIf="data.driverSegment === 'SR_DRIVER'">-->
            <!--                <div *ngIf="data?.assignsVehicles?.length > 0">-->
            <!--                  <div-->
            <!--                    *ngFor="let vehicle of data?.assignsVehicles">{{vehicle.vehicleDetails?.registrationNumber}}</div>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </td>-->
            <td style="min-width: 150px;">{{ data.createdAt | date: "dd-MM-y" }}</td>
            <!--            <td>-->
            <!--              <nz-tag *ngIf="data.active" [nzColor]="'#3ab200'" class="rounded-full">Active</nz-tag>-->
            <!--              <nz-tag *ngIf="!data.active" [nzColor]="'#ff4d4f'" class="rounded-full">Inactive</nz-tag>-->
            <!--            </td>-->
            <td  *appHasAnyPrivilege="'DRIVER_SINGLE_VIEW,DRIVER_DELETE,DRIVER_UPDATE'">
              <div class="flex gap-1">
                <button *ngIf="checkPermissionsWithUserActiveStatus(data, 'DRIVER_UPDATE')"
                        class="outline-button mr-3"
                        nz-button nzType="default"
                        (click)="goto(data?._id, 'edit')">
                  Edit
                </button>
                <button *appHasAnyPrivilege="'DRIVER_SINGLE_VIEW,DRIVER_DELETE'" class="outline-button more-dropdown"
                        nz-button
                        nz-dropdown
                        [nzDropdownMenu]="menu"
                        nzPlacement="bottomCenter">
                  <span nz-icon nzType="more" nzTheme="outline"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                    <li *ngIf="checkPermissionsWithUserActiveStatus(data, 'DRIVER_SINGLE_VIEW')" nz-menu-item
                        nz-popconfirm
                        nz-button
                        (click)="goto(data?._id, 'single-view')">
                      View
                    </li>
                    <li
                      *appHasAnyPrivilege="'TRANSFER_BOOKING_UPDATE'"
                      nz-submenu
                      nzTitle="Change Status"
                    >
                      <ul>
                        <li
                          nz-menu-item
                          nz-popconfirm
                          *ngIf="
                                data?.active === true

                              "
                          nzPopconfirmTitle="Are you sure you want change the status to In Active?"
                          [nzOkText]="'Yes'"
                          [nzCancelText]="'No'"
                          (nzOnCancel)="handleCancelSelectStatus()"
                          (nzOnConfirm)="
                                  handleOkSelectStatus(data)
                                "
                        >
                          In Active
                        </li>
                        <li
                          nz-menu-item
                          nz-popconfirm
                          *ngIf="
                                data?.active !== true
                              "
                          nzPopconfirmTitle="Are you sure you want change the status to Active?"
                          [nzOkText]="'Yes'"
                          [nzCancelText]="'No'"
                          (nzOnCancel)="handleCancelSelectStatus()"
                          (nzOnConfirm)="
                                  handleOkSelectStatus(data)
                                "
                        >
                          Active
                        </li>

                      </ul>
                    </li>
                    <li *ngIf="checkPermissionsWithUserActiveStatus(data, 'DRIVER_DELETE')" nz-menu-item nz-popconfirm
                        nz-button nzDanger
                        nzPopconfirmTitle="Are you sure you want to delete driver {{
                          data.fullName
                        }}?" (nzOnConfirm)="softDeleteConfirm(data._id)">
                      Delete
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </div>
            </td>
          </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-table-skeleton-template [columnData]="skeletonTableColumns"></app-table-skeleton-template>
    </div>
  </div>
</nz-card>
